import { useFireStore } from '../../firebase/firebase'
import { useState } from 'react'
import { Heart, HeartFilled } from 'components/misc/Icons'

const Like = ({id, liked}) => {

    const [isLiked, setIsLiked] = useState(liked)

    const addLike = async () => {
        setIsLiked(true)
        await useFireStore.collection("posts")
        .doc(id)
        .update({
            liked: true,
        });
    };

    const removeLike = () => {
        setIsLiked(false)
        useFireStore.collection("posts")
        .doc(id)
        .update({
            liked: false,
        });
    };

    return (
        <div>
            {isLiked ? (
                <button
                    onClick={() => removeLike()}
                    className="flex items-center justify-center w-8 h-8 text-red-600 dark:text-red-700 focus:outline-none">
                    <HeartFilled width="8" height="8"/>
                </button>
            ) : (
                <button
                    onClick={() => addLike()}
                    className="flex items-center justify-center w-8 h-8 text-textlight dark:text-textdark focus:outline-none">
                    <Heart width="8" height="8" stroke="1"/>
                </button>
            )}
        </div>
    )
}

export default Like
